import {
  CurrencyBalanceAttributes,
  GetProfileIncludeOptions,
  ProfileAttributes,
} from '../../profile-api-client/types/profile';
import { MembershipAttributes } from '../../profile-api-client/types/membership';

// TODO move all webhook event definition back in profile-api-client
// those event are emitted by the profile-api
export enum WebhookEventTypes {
  All = 'all',
  ProfileCreated = 'profile_created',
  LevelChanged = 'level_changed',
  PointsEarned = 'points_earned',
  PointsBurned = 'points_burned',
  PointsAdded = 'points_added',
  PointsExpired = 'points_expired',
  PointsSubtracted = 'points_subtracted',
  RewardOffered = 'reward_offered',
  IdentitiesCreated = 'identities_created',
  ProfileDeleted = 'profile_deleted',
  MembershipDeleted = 'membership_deleted',
}

export interface WebhookEventRoot {
  id: string;
  eventType: WebhookEventTypes;
  timestamp: string;
  accountId: string;
  profileId: string;
  profile: {
    id: string;
    version: number;
    firstName?: string;
    lastName?: string;
    picture?: string | null;
  };
  programId?: string;
}

export interface ProfileCreatedWebhookEvent extends WebhookEventRoot {
  eventType: WebhookEventTypes.ProfileCreated;
  programId: string;
}

export interface LevelChangedWebhookEvent extends WebhookEventRoot {
  eventType: WebhookEventTypes.LevelChanged;
  programId: string;
}

export interface IdentitiesCreatedWebhookEvent extends WebhookEventRoot {
  eventType: WebhookEventTypes.IdentitiesCreated;
  identity: {
    kind: string;
    value: string;
  };
}

export interface ProfileDeletedWebhookEvent extends WebhookEventRoot {
  eventType: WebhookEventTypes.ProfileDeleted;
  /**
   * Must be here because the webhook serializer cannot fetch profile data after
   * the profile has been deleted.
   */
  profile: ProfileAttributes;
}

export interface MembershipDeletedWebhookEvent extends WebhookEventRoot {
  eventType: WebhookEventTypes.MembershipDeleted;
  /**
   * Must be here because the webhook serializer cannot fetch profile data after
   * the profile has been deleted.
   */
  programId: string;
  profile: ProfileAttributes;
  membership: MembershipAttributes;
}

export type ProfileWebhookEvent =
  | ProfileCreatedWebhookEvent
  | LevelChangedWebhookEvent
  | IdentitiesCreatedWebhookEvent
  | MembershipDeletedWebhookEvent
  | ProfileDeletedWebhookEvent;

export interface TransactionWebhookEvent extends WebhookEventRoot {
  eventType:
    | WebhookEventTypes.PointsEarned
    | WebhookEventTypes.PointsAdded
    | WebhookEventTypes.PointsSubtracted
    | WebhookEventTypes.PointsExpired;
  sourceEventId?: string;
  programId: string;
  currencyId: string;
  ruleId?: string | null;
  amount: number;
  currencyBalance: Pick<
    CurrencyBalanceAttributes,
    | 'currencyId'
    | 'nextExpiration'
    | 'value'
    | 'totalAccumulated'
    | 'totalOverCurrencyPeriod'
    | 'totalOverLevelPeriod'
  >;
}

export interface RewardWebhookEvent extends WebhookEventRoot {
  eventType: WebhookEventTypes.PointsBurned | WebhookEventTypes.RewardOffered;
  sourceEventId?: string;
  programId: string;
  rewardId: string;
  profileRewardId: string;
  transactions: { currencyId: string; amount: number }[];
}

export type WebhookEvent = ProfileWebhookEvent | TransactionWebhookEvent | RewardWebhookEvent;

export const webhookProfileRelations = [
  GetProfileIncludeOptions.identities,
  GetProfileIncludeOptions.currencies,
  GetProfileIncludeOptions.memberships,
];
